"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGroup = exports.SelectedBtn = exports.Container = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const button_1 = __importDefault(require("@kyruus/button"));
const styled_1 = __importDefault(require("@emotion/styled"));
exports.Container = (0, styled_1.default)('div') `
  display: flex;
  align-items: center;
`;
exports.SelectedBtn = (0, styled_1.default)(button_1.default) `
  background-color: ${(0, ui_theme_1.fromTheme)('color_button_secondary_hover')};
`;
exports.ButtonGroup = (0, styled_1.default)('div') `
  display: flex;

  button {
    border-radius: 0;
    border-right: 0;
    margin: 0;

    &:first-of-type {
      border-top-left-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
      border-bottom-left-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
    }
    &:last-child {
      border-top-right-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
      border-bottom-right-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
      border-right: 1px solid ${(0, ui_theme_1.fromTheme)('color_border')};
    }
  }
`;
//# sourceMappingURL=styles.js.map